import styled from 'styled-components';
import PropTypes from 'prop-types';
import styleHelper from '@utils/styleHelper';
import { TextColors, Fonts, Spacings } from '../../../styleConstants';

const H1 = styled.h1`
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.H1};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: ${({ color }) => color};
  margin: ${Spacings.SPACING_0B};
  @media (max-width: 70.95em) {
    font-size: 24px;
  }
  @media (max-width: 47.95em) {
    font-size: 28px;
    line-height: 120%;
  }
  ${({ lineClamp }) =>
    lineClamp ? styleHelper.lineClampStyle(lineClamp) : null}
`;

export default H1;

H1.propTypes = {
  color: PropTypes.string,
  lineClamp: PropTypes.number
};

H1.defaultProps = {
  color: TextColors.BLACK,
  lineClamp: null
};
